const ChileSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111168)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M40 20C40 31.0456 31.0456 40 20 40C8.95437 40 0 31.0456 0 20C0 8.95436 20 20 20 20C20 20 35.1376 20 40 20Z"
        fill="#D80027"
      />
      <path d="M0 20C0 8.95437 8.95437 0 20 0V20C20 20 6.95648 20 0 20Z" fill="#0052B4" />
      <path
        d="M11.9054 6.95703L13.2004 10.9428H17.3913L14.0008 13.4061L15.2958 17.3919L11.9054 14.9285L8.5149 17.3919L9.8099 13.4061L6.41943 10.9428H10.6103L11.9054 6.95703Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111168">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default ChileSvg;
